"use client";
import { useCourseContext } from "..";
import { ContextCourseDetailData } from "../types";

const useCourseDetailsData = () => {
  const { dispatch, state } = useCourseContext();

  const setCourseDetailsData = ({
    category,
    courseSlug,
  }: ContextCourseDetailData) => {
    dispatch({
      type: "SET_COURSE_DETAIL_DATA",
      payload: { category, courseSlug },
    });
  };

  return {
    setCourseDetailsData,
    courseDetailData: state.courseDetailData,
  };
};

export default useCourseDetailsData;
